<div class="container-fluid mb-3">
    @if (view$ | async; as view) {
        <div class="row">
            <h1 class="mt-3 col-md-5 col-sm-12">
                {{ 'titles_consumptionReport' | translate: 'online' : 'systems' }}
            </h1>
            <div class="col-md-7 col-sm-12 mt-3 pe-0 text-end">
                <button
                    type="button"
                    class="btn btn-outline-primary"
                    (click)="export(view.criteria)">
                    {{ 'actions_export' | translate: 'online' : 'systems' }}
                </button>
                <div style="width: 530px; display: inline-block; padding-left: 1rem">
                    <app-input-search
                        (input)="setPage(1)"
                        [formControl]="searchControl"
                        [placeholder]="'reporting_SEARCH_HELP_TEXT' | translate">
                    </app-input-search>
                </div>
            </div>
            <button
                type="button"
                class="btn btn-link text-start pt-0 pb-0"
                (click)="navBackToCriteria()">
                {{ 'actions_back_to_search_criteria' | translate: 'online' : 'common' }}
            </button>
        </div>
        @if (view.loading) {
            <app-load></app-load>
        } @else {
            @if (page | async; as page) {
                @if (view.criteria.groupLevel === 'M') {
                    <app-meter-table
                        [view]="view.consumptionReports"
                        (sorting)="setSorting($event)"
                        [page]="page"
                        [pageSize]="pageSize"></app-meter-table>
                } @else if (view.criteria.groupLevel === 'L') {
                    <app-location-table
                        [view]="view.consumptionReports"
                        (sorting)="setSorting($event)"
                        [page]="page"
                        [pageSize]="pageSize"></app-location-table>
                } @else if (view.criteria.groupLevel === 'B') {
                    <app-building-table
                        [view]="view.consumptionReports"
                        (sorting)="setSorting($event)"
                        [page]="page"
                        [pageSize]="pageSize"></app-building-table>
                }
                <app-pagination
                    [collectionSize]="view.consumptionReports.length"
                    [page]="page"
                    (pageChange)="setPage($event)"
                    [(pageSize)]="pageSize"></app-pagination>
            }
        }
    } @else {
        <app-load></app-load>
    }
</div>
